export interface FinishStepContent {
  id: 'coverageReassurance' | 'congratulations' | 'excuse';
  title: string;
  description: string;
}

export interface ExcuseStepContent {
  heading: (name: string) => string;
  paragraph1: string;
  paragraph2: string;
  optionsTitle: string;
  optionsp1: (name: string) => string;
  optionsp2: string;
  links: {
    label: string;
    href: string;
  }[];
}

export interface NoWorriesStepContent {
  heading: (question: string) => string;
  paragraph1: string;
  // paragraph2: string;
}

export const congratulationsContent: NoWorriesStepContent = {
  heading: (question: string) => question,
  paragraph1: `Below you’ll see a summary of the plan you’ve selected along with final pricing.`,

  // paragraph2: `Congratulations again—you’re just a click away from being officially covered!`,
};

export const finishStepsContent: FinishStepContent[] = [
  {
    id: 'coverageReassurance',
    title: 'No worries—you’re always covered here.',
    description:
      "Thanks for checking out your options! Even if now’s not the right time, we’re glad you stopped by. Life changes, and when you're ready to explore coverage again—whether it’s health, dental, or something extra—we’ll be here to help. And remember, Alia is always just a click away if you have questions or want to revisit your choices anytime",
  },
  {
    id: 'congratulations',
    title: 'Congratulations!',
    description:
      'You’ve been approved for your medical insurance, and your final premium is locked in — great job taking this important step toward protecting your health. If you ever want to make changes to the plans you selected, no problem!',
  },
  {
    id: 'excuse',
    title: 'We are Sorry!',
    description:
      'We’re sorry to let you know that you haven’t been approved for medical insurance through this plan. But don’t worry—there are still great options available to you!',
  },
];
